export type InterviewScore = "strong_no_hire" | "no_hire" | "hire" | "strong_hire";

export type PanelStatus = "no_panel" | "collecting" | "awaiting_final" | "finalized";

export const INTERVIEW_SCORES: InterviewScore[] = [
  "strong_no_hire",
  "no_hire",
  "hire",
  "strong_hire",
];

export const INTERVIEW_SCORE_LABELS: Record<InterviewScore, string> = {
  strong_no_hire: "Strong No Hire",
  no_hire: "No Hire",
  hire: "Hire",
  strong_hire: "Strong Hire",
};

/**
 * Badge styling for each score, in increasing order of favorability.
 * These are used everywhere a score is rendered as a pill so it stays consistent.
 */
export const INTERVIEW_SCORE_COLORS: Record<InterviewScore, string> = {
  strong_no_hire: "bg-red-100 text-red-800 ring-1 ring-red-200",
  no_hire: "bg-orange-100 text-orange-800 ring-1 ring-orange-200",
  hire: "bg-green-100 text-green-800 ring-1 ring-green-200",
  strong_hire: "bg-emerald-100 text-emerald-800 ring-1 ring-emerald-200",
};

export const INTERVIEW_SCORE_DESCRIPTIONS: Record<InterviewScore, string> = {
  strong_no_hire: "Clear signal: do not hire. Significant concerns.",
  no_hire: "Leaning against hiring. Concerns outweigh strengths.",
  hire: "Leaning toward hiring. Strengths outweigh concerns.",
  strong_hire: "Clear signal: hire. Strong performance across the board.",
};

export const PANEL_STATUS_LABELS: Record<PanelStatus, string> = {
  no_panel: "Panel Pending",
  collecting: "Feedback In Progress",
  awaiting_final: "Awaiting Final Decision",
  finalized: "Decision Finalized",
};

export const PANEL_STATUS_COLORS: Record<PanelStatus, string> = {
  no_panel: "bg-gray-100 text-gray-700",
  collecting: "bg-amber-100 text-amber-800",
  awaiting_final: "bg-violet-100 text-violet-800",
  finalized: "bg-teal-100 text-teal-800",
};
